// ThemeSwitcher.js
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { InputAdornment, MenuItem } from "@mui/material";
import { TrackedTextField } from "src/theme/StyledFields";
import { useContext } from "react";
import { ThemeContext } from "./ThemeContext";

const ThemeSwitcher = () => {
  const { darkMode, setDarkMode } = useContext(ThemeContext);

  return (
    <TrackedTextField
      select
      size={"small"}
      label={"Theme"}
      variant={"outlined"}
      value={darkMode}
      onChange={(e) => {
        window.localStorage.setItem("themeMode", e.target.value);
        setDarkMode(e.target.value);
      }}
      fullWidth
      data-attr="theme-switcher_select"
      InputProps={{
        sx: { fontSize: 12 },
        startAdornment: (
          <InputAdornment position="start">
            <SettingsBrightnessIcon size={"small"} />
          </InputAdornment>
        )
      }}
    >
      <MenuItem value={true}>
        Dark Mode (beta)
      </MenuItem>
      <MenuItem value={false}>
        Light Mode
      </MenuItem>
    </TrackedTextField>
  );
};

export default ThemeSwitcher;
